import axios from 'axios'
import {Message} from 'element-ui';
import qs from 'qs'
import {urlcode} from "@/config.js"
import {hideLoading, showLoading} from "@/utils/loading";


//false为线上环境，true为本地环境
let isVip = true;

function checkStatus(response) {
  // loading
  // 如果http状态码正常，则直接返回数据
  if (response && (response.status === 200 || response.status === 304 || response.status === 400)) {
    return response
    // 如果不需要除了data之外的数据，可以直接 return response.data
  }
  // 异常状态下，把错误信息返回去
  return {
    status: -404,
    msg: '网络异常'
  }
}

function checkCode(res) {
  // 如果code异常(这里已经包括网络错误，服务器错误，后端抛出的错误)，可以弹出一个错误提示，告诉用户
  if (res.data.status === 404) {
    console.log('网络错误，服务器错误，后端抛出的错误')
  }
  if (res.data && (res.data.stateCode !== '001')) {
    // console.log(res.data.message)
  }
  return res;
}

function returnError(res) {
  return res;
}

export default {
  post(url, data, isJson) {
    // console.log('url',url)
    showLoading()
    console.log(isJson, 'isJson')
    const token = sessionStorage.getItem('token')
    let newurl = url.trim()
    let dataParams;
    isJson ? dataParams = data : dataParams = qs.stringify(data)
    if (token) {
      var requireHeader = {
        'Content-Type': isJson ? "application/json;" : 'application/x-www-form-urlencoded; charset=UTF-8',
        // "Content-Type":"application/json;",
        'X-Access-Token': token
      }
    } else {
      var requireHeader = {
        'Content-Type': isJson ? "application/json;" : 'application/x-www-form-urlencoded; charset=UTF-8',
      }
    }
    // console.log(requireHeader)
    url = urlcode + newurl

    return axios({
      withCredentials: true,
      crossDomain: true,
      method: 'post',
      //  baseURL: '',
      url,
      data: dataParams,
      timeout: 50000,
      /*      transformResponse: [data => {
              var JSONbig = require('json-bigint');
              data = JSONbig.parse(data);
              if (data.result.sysUser) {
                data.result.sysUser.id = data.result.sysUser.id.toString();
              }

              return data;
            }],*/
      headers: requireHeader
    }).then(
      (res) => {
        hideLoading()
        if (res.data.success || res.data.succeed) {
          return checkCode(res)
        } else {
          this.loading = false
          Message({
            message: res.data.message || '',
            type: 'error',
            duration: 2000
          })
          return checkCode(res)
        }

      }
    )
      .catch(res => {
        hideLoading()
        // console.log(res)
        this.loading = false
        Message({
          showClose: true,
          message: res.response.data.message || '',
          type: 'error'
        })
        if (res.response.status == 401) {
          sessionStorage.removeItem('token')
        }
        return returnError(res)
      })
  },

  /**
   * GET请求方法
   * @param {string} url - 请求URL
   * @param {object} params - 请求参数
   * @param {object} config - 额外配置
   * @param {string} config.responseType - 响应类型，如 'blob' 用于文件下载
   * @param {object} config.headers - 自定义请求头
   * @param {number} config.timeout - 超时时间
   *
   * 使用示例：
   * // 普通JSON请求
   * this.$api.get('/api/users', { page: 1 })
   *
   * // 文件下载请求
   * this.$api.get('/api/download', { id: 1 }, { responseType: 'blob' })
   */
  get(url, params, config = {}) {
    // showLoading()
    // const headerAuth = sessionStorage.getItem('headerAuth')
    const token = sessionStorage.getItem('token')

    // 基础请求头
    let requireHeader = {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    }

    // 添加token
    if (token) {
      requireHeader['X-Access-Token'] = token
    }

    // 合并自定义headers
    if (config.headers) {
      requireHeader = { ...requireHeader, ...config.headers }
    }

    let newurl = url.trim()
    url = urlcode + newurl

    // 构建axios配置
    const axiosConfig = {
      withCredentials: true,
      crossDomain: true,
      method: 'get',
      url,
      params, // get 请求时带的参数
      timeout: config.timeout || 50000,
      headers: requireHeader,
      ...config // 合并其他配置（如responseType等）
    }

    return axios(axiosConfig).then(
      (res) => {
        // 检查是否为文件流响应
        const isFileStream = this.isFileStreamResponse(res, config)

        if (isFileStream) {
          // 文件流直接返回完整响应对象
          return res
        }

        // 普通JSON响应的处理逻辑
        // hideLoading()
        if (res.data.success === true || res.data.succeed === true) {
          return checkCode(res)
        } else {
          this.loading = false
          Message({
            message: res.data.message || res.data.error.msg || '请求失败',
            type: 'error',
            duration: 2000
          })
          return checkCode(res)
        }
      }
    ).catch((res) => {
      // hideLoading()
      this.loading = false

      // 处理错误信息
      let errorMessage = '请求失败'
      if (res.response.data.message) {
        errorMessage = res.response.data.message
      } else if (res.message) {
        errorMessage = res.message
      }

      Message({
        showClose: true,
        message: errorMessage,
        type: 'error'
      })

      if (res.response.status === 401) {
        sessionStorage.removeItem('token')
      }

      return Promise.reject(res)
    })
  },

  // 判断是否为文件流响应
  isFileStreamResponse(response, config) {
    // 1. 检查配置中是否指定了responseType为blob
    if (config.responseType === 'blob') {
      return true
    }

    // 2. 检查响应头的Content-Type
    const contentType = response.headers['content-type'] || response.headers['Content-Type'] || ''

    // 常见的文件流Content-Type
    const fileStreamTypes = [
      'application/pdf',
      'application/octet-stream',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'image/',
      'video/',
      'audio/',
      'application/zip',
      'application/x-zip-compressed'
    ]

    // 检查Content-Type是否匹配文件流类型
    const isFileType = fileStreamTypes.some(type => contentType.includes(type))

    // 3. 检查响应数据是否为Blob类型
    const isBlob = response.data instanceof Blob

    // 4. 检查Content-Disposition头（通常用于文件下载）
    const contentDisposition = response.headers['content-disposition'] || response.headers['Content-Disposition'] || ''
    const hasAttachment = contentDisposition.includes('attachment')

    return isFileType || isBlob || hasAttachment
  },
  put(url, data, isJson) {
    showLoading()
    const token = sessionStorage.getItem('token')
    let newurl = url.trim()
    let dataParams;
    isJson ? dataParams = data : dataParams = qs.stringify(data)
    if (token) {
      var requireHeader = {
        'Content-Type': isJson ? "application/json;" : 'application/x-www-form-urlencoded; charset=UTF-8',
        // "Content-Type":"application/json;",
        'X-Access-Token': token
      }
    } else {
      var requireHeader = {
        'Content-Type': isJson ? "application/json;" : 'application/x-www-form-urlencoded; charset=UTF-8',
      }
    }
    url = urlcode + newurl

    return axios({
      withCredentials: true,
      crossDomain: true,
      method: 'put',
      //  baseURL: '',
      url,
      data: dataParams,
      timeout: 50000,
      headers: requireHeader
    }).then(
      (res) => {
        hideLoading()
        if (res.data.success == true) {
          return checkCode(res)
        } else {
          this.loading = false
          Message({
            message: res.data.message,
            type: 'error',
            duration: 2000
          })
          return
        }

      }
    )
      .catch(res => {
        hideLoading()
        // console.log(res)
        this.loading = false
        Message({
          showClose: true,
          message: res.response.data.message,
          type: 'error'
        })
        if (res.response.status == 401) {
          sessionStorage.removeItem('token')
        }

        return returnError(res)
      })
  },
  delete(url, params, url2) {
    showLoading()
    const token = sessionStorage.getItem('token')
    if (token) {
      var requireHeader = {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'X-Access-Token': token
      }

    } else {
      var requireHeader = {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      }
    }
    let newurl = url.trim()
    url = urlcode + newurl
    return axios({
      withCredentials: true,
      crossDomain: true,
      method: 'delete',
      // baseURL: '',
      url,
      params, // get 请求时带的参数
      timeout: 50000,
      headers: requireHeader
    }).then(
      (res) => {
        hideLoading()
        if (res.data.success == true) {
          return checkCode(res)
        } else {
          this.loading = false
          Message({
            message: res.data.message,
            type: 'error',
            duration: 2000
          })
          return
        }

      }
    ).catch((res) => {
      hideLoading()
      this.loading = false
      Message({
        showClose: true,
        message: res.response.data.message,
        type: 'error'
      })
      if (res.response.status == 401) {
        sessionStorage.removeItem('token')
      }
    })
  }

}



// WEBPACK FOOTER //
// ./src/utils/request.js